// The vehicle photo placed in a financing composition is picked by its order, starting at 1.
export const MIN_SOURCE_PHOTO_INDEX = 1;
